import { memo } from 'react';

import { type AirActionTrackingLocation } from '@air/analytics';
import { Tooltip } from '@air/primitive-tooltip';

import { TABLE_ASSET_TITLE } from '~/constants/testIDs';
import { preventDefaultMouseEvent } from '~/utils/ClickUtils';

export type BaseTableAssetTitleProps = {
  title: string;
  onClick: (location: AirActionTrackingLocation) => void;
  onCmdClick?: (location: AirActionTrackingLocation) => void;
  additionalProps?: Record<string, unknown>;
};

export const BaseTableAssetTitle = memo(
  ({ onClick, onCmdClick, title, additionalProps = {} }: BaseTableAssetTitleProps) => (
    <Tooltip label={title} side="top" sideOffset={4}>
      <button
        className="block max-w-full truncate text-left font-medium ads:text-primary text-14 text-gray-12 hover:underline"
        data-testid={TABLE_ASSET_TITLE}
        // biome-ignore lint/performance/noJsxPropsBind: the click handler branches on metaKey using this row's onClick and onCmdClick
        onClick={(event) => {
          if ((event.metaKey || event.ctrlKey) && onCmdClick) {
            onCmdClick?.('table-cell');
          } else {
            onClick('table-cell');
          }
        }}
        onMouseDown={preventDefaultMouseEvent}
        {...additionalProps}
      >
        {title}
      </button>
    </Tooltip>
  ),
);

BaseTableAssetTitle.displayName = 'BaseTableAssetTitle';
